export type SubscriptionNode = {
  id: string;
  name: string;
  type: number;
  children: SubscriptionNode[];

  pathFromRoot?: string;

  isDropdownExpand?: boolean; // Tenant

  isAllSelected?: boolean; // Cdm

  isCheckedAttribute?: boolean; // Attribute

  isApprovedAttribute?: boolean; // Attribute (pre-approved, locked)
  
  isEO14117Protected?: boolean; // Cdm

  primaryKey?: string | null; // Cdm
  alternateKeys?: string[] | null; // Cdm
  compositeKey?: string[] | null; // Cdm

  keyLabel?: string; // Attribute
};

export enum SubscriptionNodeTypes {
  Tenant = 0,
  Cdm,
  Attribute,
  EgressOption,
  ExposableCdm,
  RequiredAttribute,
}
